__turbopack_context__.v({
  "centralContainer": "CentralContainer-module-scss-module__ZGXWqG__centralContainer",
});
